<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <div id="qr-complaint-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
          <v-card tile :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'">
            <PageHeader>
              <template #action>
                <div class="d-flex align-center flex-grow-1 justify-end">
                  <v-checkbox
                    v-model="loadAll"
                    dense
                    hide-details
                    class="ma-0 mr-2"
                    color="primary"
                    label="Hepsini Yükle"
                  />
                  <v-btn
                    color="secondary"
                    depressed
                    rounded="pill"
                    class="text-capitalize px-10 ml-auto"
                    @click="openPublicForm"
                  >
                    Yeni Şikayet Ekle
                  </v-btn>
                  <v-btn icon class="ml-2" @click="reload">
                    <v-icon>{{ icons.mdiRefresh }}</v-icon>
                  </v-btn>
                </div>
              </template>
            </PageHeader>

            <v-data-table
              :headers="headers"
              :items="rows"
              :loading="loading"
              :height="pageStore.tableHeight"
              loader-height="2"
              :items-per-page="-1"
              :mobile-breakpoint="100"
              fixed-header
              hide-default-footer
            >
              <!-- Load More -->
              <template v-slot:[`body.append`] v-if="loadMoreVisible">
                <tr>
                  <td :colspan="headers.length">
                    <div class="text-center" v-intersect.quiet="loadMore">
                      <v-progress-circular
                        v-if="rows.length > 0"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Arama Alanı (cash-report stili) -->
              <template v-slot:[`body.prepend`]>
                <tr class="data-table-body-search">
                  <!-- ID -->
                  <td class="pa-0">
                    <v-text-field
                      v-model="filters.id"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td>

                  <!-- Oluşturan -->
                  <td class="pa-0">
                    <v-text-field
                      v-model="filters.createat"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td>

                  <!-- Oluşturma Tarihi (şimdilik pasif) -->
                  <td class="pa-0">
                    <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                  </td>

                  <!-- Ref -->
                  <!-- <td class="pa-0">
                    <v-text-field
                      v-model="filters.refno"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td> -->

                  <!-- Kanal -->
                  <td class="pa-0">
                    <v-select
                      v-if="canSeePersonnel"
                      v-model="filters.qr_channel"
                      :items="channelItems"
                      item-text="text"
                      item-value="value"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                    <v-text-field v-else filled disabled class="rounded-0 elevation-0" hide-details />
                  </td>

                  <!-- Kategori -->
                  <td class="pa-0">
                    <v-autocomplete
                      v-model="filters.category"
                      :items="categories"
                      :loading="categoriesLoading"
                      item-text="text"
                      item-value="value"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td>

                  <!-- Şube Kodu -->
                  <td class="pa-0">
                    <v-autocomplete
                      v-model="filters.unit"
                      :items="branches"
                      :loading="branchesLoading"
                      item-text="display"
                      item-value="customer"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td>

                  <!-- Özet -->
                  <td class="pa-0">
                    <v-text-field
                      v-model="filters.stext"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </td>

                  <!-- İşlem (pasif) -->
                  <td class="pa-0">
                    <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                  </td>
                </tr>
              </template>

              <template v-slot:[`item.qr_channel`]="{ item }">
                <v-chip
                  x-small
                  outlined
                  class="qr-chip-channel"
                  :class="item.qr_channel === 'personnel' ? 'qr-chip-channel--personnel' : 'qr-chip-channel--public'"
                >
                  {{ item.qr_channel }}
                </v-chip>
              </template>

              <template v-slot:[`item.category`]="{ item }">
                <div class="text-truncate" style="max-width: 220px">
                  {{ item.category_txt || getCategoryLabel(item) }}
                </div>
              </template>

              <template v-slot:[`item.stext`]="{ item }">
                <div class="qr-stext">
                  {{ item.stext || "-" }}
                </div>
              </template>

              <template v-slot:[`item.branch_name1`]="{ item }">
                <div class="text-truncate" style="max-width: 220px">
                  {{ item.branch_display || item.branch_officename || item.branch_name1 || "-" }}
                </div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn small text color="primary" @click="openDetail(item)">Detay</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="detailDialog"
      scrollable
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :max-width="$vuetify.breakpoint.smAndDown ? '100%' : 980"
      :z-index="2100"
    >
      <v-card rounded="xl" class="qr-detail-card">
        <v-card-title class="d-flex align-center px-6 py-4 qr-detail-title">
          <div class="d-flex flex-column">
            <div class="font-weight-bold text-h6">Şikayet & Öneri Detayı</div>
          </div>
          <v-spacer />
          <div class="d-flex align-center mr-2" v-if="selected && !$vuetify.breakpoint.smAndDown">
            <v-chip small class="mr-2" color="primary" outlined>
              ID: {{ selected.id }}
            </v-chip>
            <v-chip small class="mr-2" color="primary" outlined>
              Ref: {{ selected.refno || "-" }}
            </v-chip>
            <v-chip
              x-small
              outlined
              class="qr-chip-channel"
              :class="selected.qr_channel === 'personnel' ? 'qr-chip-channel--personnel' : 'qr-chip-channel--public'"
            >
              {{ selected.qr_channel || "-" }}
            </v-chip>
          </div>
          <v-btn
            icon
            class="qr-detail-close"
            :class="{ 'qr-detail-close--mobile': $vuetify.breakpoint.smAndDown }"
            @click="detailDialog = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="qr-detail-divider" />
        <v-card-text v-if="selected" class="px-6 py-6">
          <v-row dense>
            <v-col cols="12" md="5" class="d-flex">
              <v-sheet class="qr-panel pa-4 flex-grow-1" rounded="lg">
                <div class="qr-kv">
                  <div class="qr-k">Kategori</div>
                  <div class="qr-v">{{ selected.category_txt || "-" }}</div>
                </div>
                <div class="qr-kv">
                  <div class="qr-k">Şube</div>
                  <div class="qr-v">
                    <div class="font-weight-medium">
                      {{ selected.branch_officename || selected.branch_name1 || "-" }}
                    </div>
                  </div>
                </div>
                <div class="qr-kv">
                  <div class="qr-k">Oluşturan</div>
                  <div class="qr-v">{{ selected.createat || selected.createdat || "-" }}</div>
                </div>
                <div class="qr-kv">
                  <div class="qr-k">Oluşturma Tarihi</div>
                  <div class="qr-v">{{ selected.createdatetime || "-" }}</div>
                </div>
                <div class="qr-kv">
                  <div class="qr-k">IP</div>
                  <div class="qr-v">{{ selected.ip || "-" }}</div>
                </div>

                <template v-if="selected.qr_channel === 'public'">
                  <div class="qr-kv">
                    <div class="qr-k">Telefon</div>
                    <div class="qr-v">{{ selected.phone || "-" }}</div>
                  </div>
                  <div class="qr-kv">
                    <div class="qr-k">E-posta</div>
                    <div class="qr-v qr-v--wrap">{{ selected.email || "-" }}</div>
                  </div>
                  <div v-if="selected.phone || selected.email" class="qr-kv">
                    <div class="qr-k">Geri Bildirim</div>
                    <div class="qr-v">{{ feedbackLabel(selected.no_feedback) }}</div>
                  </div>
                </template>
                <div class="qr-kv">
                  <div class="qr-k">KVKK 1</div>
                  <div class="qr-v">{{ yn(selected.kvkk1) }}</div>
                </div>
                <div class="qr-kv">
                  <div class="qr-k">KVKK 2</div>
                  <div class="qr-v">{{ yn(selected.kvkk2) }}</div>
                </div>
              </v-sheet>
            </v-col>

            <v-col cols="12" md="7" class="d-flex flex-column">
              <v-sheet class="qr-panel pa-4" rounded="lg" style="flex: 0 0 auto">
                <div class="text-caption text--secondary mb-2">Mesaj</div>
                <div class="white-space-pre-line text-body-2">{{ selected.message || "-" }}</div>
              </v-sheet>

              <v-sheet class="qr-panel pa-4 mt-4 qr-attachments-panel" rounded="lg">
                <div class="d-flex align-center mb-3">
                  <div class="text-caption text--secondary">Ekler</div>
                  <v-spacer />
                  <div class="text-caption text--secondary">
                    {{ Array.isArray(selected.medyalar) ? selected.medyalar.length : 0 }} adet
                  </div>
                </div>

                <template v-if="Array.isArray(selected.medyalar) && selected.medyalar.length">
                  <v-row dense>
                    <v-col
                      v-for="m in selected.medyalar"
                      :key="m.uploadid || m.dosya_adi || m.gdosya_adi"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-sheet class="qr-media-tile" rounded="lg" @click="openUrl(mediaUrl(m))">
                        <v-img
                          v-if="isJpegMedia(m)"
                          :src="mediaUrl(m)"
                          height="140"
                          class="qr-media-img"
                          contain
                        />
                        <div v-else class="qr-media-placeholder">
                          <div class="text-caption text--secondary">Dosya</div>
                        </div>
                        <div class="pa-3">
                          <div class="text-body-2 text-truncate" :title="m.gdosya_adi || m.uploadid">
                            {{ m.gdosya_adi || m.uploadid || "Dosya" }}
                          </div>
                          <div class="text-caption text--secondary text-truncate">
                            {{ m.dosya_tipi || (isJpegMedia(m) ? "resim" : "") }}
                          </div>
                        </div>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </template>
                <template v-else>
                  <div class="qr-empty-attachments">
                    <div class="text-caption text--secondary">Bu kayıtta ek bulunmuyor.</div>
                  </div>
                </template>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { computed, getCurrentInstance, onMounted, onUnmounted, ref, watch } from "@vue/composition-api";
import { mdiClose, mdiRefresh, mdiFileDocumentOutline, mdiMagnify } from "@mdi/js";
import { qrBranchList, qrCategoryListAsJson, qrList } from "@/api/qrActions";
import PageHeader from "@/components/PageHeader/Index.vue";
import { usePageStore } from "@/stores/pageHeader";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const vm = getCurrentInstance()?.proxy;
    const pageStore = usePageStore();
    const loading = ref(false);
    const loadingMore = ref(false);
    const rows = ref([]);
    const total = ref(0);
    const page = ref(1);
    const itemsPerPage = ref(25);
    const loadMoreVisible = ref(false);
    const isEnd = ref(false);
    const loadAll = ref(false);

    const filters = ref({
      id: "",
      createat: "",
      stext: "",
      refno: "",
      category: null,
      unit: "",
      message: "",
      qr_channel: "all",
    });

    const channelItems = [
      { text: "Tümü", value: "all" },
      { text: "Genel (public)", value: "public" },
      { text: "Personel (personnel)", value: "personnel" },
    ];

    const canSeePersonnel = computed(() => {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
/*       if (userData?.role === "SUPER") return true; */
      return !!vm?.$ability?.can?.("read", "asl-qr-complaint-personnel");
    });

    const categories = ref([]);
    const categoriesLoading = ref(false);

    const branches = ref([]);
    const branchesLoading = ref(false);

    const normalizeCategoryResponse = (res) => {
      if (Array.isArray(res)) {
        const first = res[0];
        if (first && typeof first === "object" && ("key" in first) && ("value" in first)) {
          return res
            .filter((x) => x && typeof x === "object" && ("key" in x) && ("value" in x))
            .map((x) => ({ value: String(x.key), text: String(x.value) }));
        }

        const obj = res[0] && typeof res[0] === "object" ? res[0] : {};
        return Object.entries(obj).map(([value, text]) => ({ value: String(value), text: String(text) }));
      }
      if (res && typeof res === "object") {
        const detail = res.detail || res.response || res.data || res;
        if (Array.isArray(detail)) return normalizeCategoryResponse(detail);
      }
      return [];
    };

    const loadBranches = async () => {
      branchesLoading.value = true;
      try {
        const res = await qrBranchList();
        if (res?.error === 0) {
          const list = res.detail || [];
          branches.value = list.map(b => {
            const officename = b?.branch_officename
            const name1 = b?.branch_name1
            const display = officename || name1 || b?.display || ""
            return { ...b, display }
          });
          return;
        }
        branches.value = [];
      } catch (e) {
        branches.value = [];
      } finally {
        branchesLoading.value = false;
      }
    };

    const loadCategories = async () => {
      categoriesLoading.value = true;
      try {
        // Filtre seçenekleri "all" kanala göre dolmalı
        const res = await qrCategoryListAsJson({ qr_channel: "all" });
        categories.value = normalizeCategoryResponse(res);
      } catch (e) {
        categories.value = [];
      } finally {
        categoriesLoading.value = false;
      }
    };

    const categoryMap = computed(() => {
      const map = new Map();
      categories.value.forEach((c) => map.set(String(c.value), c.text));
      return map;
    });

    const getCategoryLabel = (item) => {
      const raw =
        item?.category ??
        item?.category_id ??
        item?.categoryId ??
        item?.kategori_id ??
        item?.kategori;
      if (raw === undefined || raw === null || raw === "") return "-";
      const key = String(raw);
      return categoryMap.value.get(key) || key;
    };

    const headers = computed(() => [
      { text: "ID", value: "id", width: 90 },
      { text: "Oluşturan", value: "createat", width: 170 },
      { text: "Oluşturma Tarihi", value: "createdatetime", width: 170 },
   /*    { text: "Ref", value: "refno" }, */
      { text: "Kanal", value: "qr_channel", width: 120 },
      { text: "Şikayet Kategorisi", value: "category", width: 220 },
      { text: "Şube", value: "branch_name1" ,width: 220 },
      { text: "Özet", value: "stext", width: 220 },
      { text: "İşlem", value: "actions", sortable: false, width: 90 },
    ]);

    const detailDialog = ref(false);
    const selected = ref(null);

    const openDetail = (item) => {
      selected.value = item;
      detailDialog.value = true;
    };

    const yn = (v) => (String(v ?? "0") === "1" ? "Evet" : "Hayır");

    const feedbackLabel = (v) => {
      if (v === undefined || v === null || v === "") return "-";
      return String(v) === "1" ? "İstemiyor" : "İstiyor";
    };

    const normalizeUrl = (url) => {
      if (!url) return "";
      if (String(url).startsWith("http")) return url;
      const base = process.env.VUE_APP_URL || window.location.origin;
      return `${String(base).replace(/\/$/, "")}/${String(url).replace(/^\//, "")}`;
    };

    const mediaUrl = (m) => normalizeUrl(m?.dosya_adi || m?.file || m?.url || "");

    const isJpegMedia = (m) => {
      const probe = String(m?.gdosya_adi || m?.dosya_adi || "").toLowerCase();
      return probe.endsWith(".jpg") || probe.endsWith(".jpeg") || String(m?.dosya_tipi || "").toLowerCase() === "resim";
    };

    const openUrl = (url) => {
      const u = String(url || "");
      if (!u) return;
      window.open(u, "_blank", "noopener,noreferrer");
    };

    const openPublicForm = () => {
      const resolved = vm?.$router?.resolve?.({ name: "qr-complaint-public" });
      const href = (resolved && resolved.href) || "/qr/public";
      window.open(href, "_blank", "noopener,noreferrer");
    };

    const buildSearch = () => ({
      id: filters.value.id || "",
      createat: filters.value.createat || "",
      stext: filters.value.stext || "",
      refno: filters.value.refno || "",
      category: filters.value.category || "",
      unit: filters.value.unit || "",
      message: filters.value.message || "",
      // Kategori filtresi seçiliyse listede "all" gitmeli (kanal filtresi ne olursa olsun)
      qr_channel: filters.value.category ? "all" : canSeePersonnel.value ? filters.value.qr_channel : "public",
    });

    const fetchList = async ({ append = false } = {}) => {
      if (append) loadingMore.value = true;
      else loading.value = true;
      try {
        const options = { page: page.value, itemsPerPage: itemsPerPage.value };
        const search = buildSearch();

        const res = await qrList({ options, search });
        if (res?.error === 0) {
          const incomingRaw = res?.response?.result || [];
          const incoming = incomingRaw.map((it) => ({
            ...it,
            branch_display: it?.branch_officename || it?.branch_name1 || "-",
          }));
          rows.value = append ? rows.value.concat(incoming) : incoming;
          total.value = Number(res?.response?.pagination?.totalRec || 0);
          isEnd.value = rows.value.length >= total.value || incoming.length === 0;
          pageStore.downloadData = rows.value;

          loadMoreVisible.value = !isEnd.value && rows.value.length > 0;
          return;
        }

        Vue.swal({
          title: "Hata",
          text: res?.msg || "Liste alınamadı.",
          icon: "warning",
          background: "#FF4C51",
          confirmButtonColor: "#000",
        });
      } catch (e) {
        Vue.swal({
          title: "Hata",
          text: e?.message || "Liste alınamadı.",
          icon: "warning",
          background: "#FF4C51",
          confirmButtonColor: "#000",
        });
      } finally {
        loading.value = false;
        loadingMore.value = false;
      }
    };

    const reload = () => {
      page.value = 1;
      isEnd.value = false;
      rows.value = [];
      pageStore.downloadData = [];
      fetchList({ append: false });
    };

    const loadMore = () => {
      if (loading.value || loadingMore.value) return;
      if (isEnd.value) return;
      page.value += 1;
      fetchList({ append: true });
    };

    watch(
      filters,
      () => {
        page.value = 1;
        isEnd.value = false;
        rows.value = [];
        pageStore.downloadData = [];
        fetchList({ append: false });
      },
      { deep: true }
    );

    watch(canSeePersonnel, (val) => {
      if (!val) filters.value.qr_channel = "public";
    });

    // Kategori seçenekleri kanaldan bağımsız (all) yüklendiği için
    // qr_channel değişiminde kategoriyi sıfırlama/yeniden çekme yapmıyoruz.

    watch(loadAll, (val) => {
      page.value = 1;
      isEnd.value = false;
      itemsPerPage.value = val ? 1000 : 25;
      rows.value = [];
      pageStore.downloadData = [];
      fetchList({ append: false });
    });

    const pageSettings = () => {
      pageStore.pageTitle = "QR Şikayet & Öneri";
      pageStore.pageIcon = mdiFileDocumentOutline;
      pageStore.hasFullScreen = false;
      pageStore.hasActions = true;
      pageStore.hasDownload = true;
      pageStore.hasDownloadApi = false;
      pageStore.hasDateRange = false;
      pageStore.hasDateRangeAll = false;

      pageStore.downloadHeader = {
        ID: "id",
        Oluşturan: "createat",
        "Oluşturma Tarihi": "createdatetime",
        Kanal: "qr_channel",
        "Şikayet Kategorisi": "category_txt",
        Şube: "branch_display",
        Özet: "stext",
      };
    };

    onMounted(() => {
      pageSettings();
      loadBranches();
      loadCategories();
      reload();
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    return {
      pageStore,
      loading,
      rows,
      total,
      loadAll,
      filters,
      headers,
      channelItems,
      canSeePersonnel,
      categories,
      categoriesLoading,
      branches,
      branchesLoading,
      getCategoryLabel,
      fetchList,
      reload,
      loadMore,
      loadMoreVisible,
      detailDialog,
      selected,
      openDetail,
      yn,
      feedbackLabel,
      normalizeUrl,
      mediaUrl,
      isJpegMedia,
      openUrl,
      openPublicForm,
      icons: { mdiClose, mdiRefresh, mdiMagnify },
    };
  },
};
</script>

<style scoped>
.white-space-pre-line {
  white-space: pre-line;
}

.qr-detail-card {
  overflow: hidden;
}

.qr-detail-title {
  position: relative;
}

.qr-detail-close--mobile {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}

.qr-detail-close--mobile .v-icon {
  font-size: 22px;
}

.qr-media-img {
  background: rgba(0, 0, 0, 0.04);
}

.qr-detail-divider {
  opacity: 0.35;
}

.qr-chip-channel {
  background: transparent !important;
}

.qr-chip-channel.qr-chip-channel--public {
  border-color: #1976d2 !important;
  color: #1976d2 !important;
}

.qr-chip-channel.qr-chip-channel--personnel {
  border-color: #fb8c00 !important;
  color: #fb8c00 !important;
}

.qr-panel {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
}

.qr-kv {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 0;
  min-width: 0;
}

.qr-kv + .qr-kv {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.qr-k {
  flex: 0 0 120px;
  font-size: 12px;
  opacity: 0.75;
}

.qr-v {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  font-weight: 500;
  word-break: break-word;
}

.qr-v--truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  word-break: normal;
}

.qr-v--wrap {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.qr-attachments-panel {
  flex: 1 1 auto;
  min-height: 0;
}

.qr-empty-attachments {
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1px dashed rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.02);
}

.qr-media-tile {
  cursor: pointer;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: transform 120ms ease, border-color 120ms ease;
}

.qr-media-tile:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.12);
}

.qr-media-placeholder {
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.02);
}

.qr-stext {
  max-width: 520px;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>

